export const MONTHS_IN_YEAR = 12;
/**
 * Options for formatting a numeric value as currency.
 * @typedef {object} CurrencyOptions
 * @property {number} minimumFractionDigits - The minimum number of decimal places to display.
 * @property {number} maximumFractionDigits - The maximum number of decimal places to display.
 * @property {string} style - The currency format style, e.g. "currency".
 * @property {string} currency - The ISO currency code, e.g. "USD".
 */
export const MAX_MONTHLY_INCOME = 83333;
export const MAX_ANNUAL_INCOME = 1000000;

export const currencyOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    style: 'decimal' as const,
};

/**
 * Converts an annual income value to a monthly income value.
 * @param {number} annualIncome - The annual income value.
 * @returns {number} The monthly income value.
 */
export const toMonthlyIncome = (annualIncome: number): number => {
    if (annualIncome < 0) {
        throw new Error('Annual income cannot be less than 0.');
    }
    return Math.floor(annualIncome / MONTHS_IN_YEAR);
};


/**
 * Converts a monthly income value to an annual income value.
 * @param {number} monthlyIncome - The monthly income value.
 * @returns {number} The annual income value.
 */
export const toAnnualIncome = (monthlyIncome: number): number => {
    if (monthlyIncome < 0) {
        throw new Error('Monthly income cannot be less than 0.');
    }
    return monthlyIncome * MONTHS_IN_YEAR;
};

/**
 * Removes non-numeric characters from an input string.
 * @param {string} value - The input string.
 * @param {RegExp} [filter=/[^0-9]/g] - The regular expression filter to use, defaults to /[^0-9]/g.
 * @returns {string} The input string with non-numeric characters removed.
 */
export const cleanNumericInput = (value: string, filter: RegExp = /[^0-9]/g): string => {
    return value?.replace(filter, '');
};

export const isRangeValid = (value: any) => {
    const number = cleanNumericInput(value);
    return Number(number) >= 100 && Number(number) <= MAX_MONTHLY_INCOME;
};